export default __webpack_public_path__ + "static/media/stars.0acbb121.png";